import { css } from '@emotion/react'

export const cssTable = css`
  .handsontable .wtHolder {
    transform: none !important;
    will-change: auto !important;
  }

  .handsontable th,
  .handsontable td {
    border-color: #cad8de;
  }

  .handsontable.ht_clone_inline_start.ht_clone_left tr th {
    border-left-color: #cad8de !important;
  }

  .handsontable.ht_clone_top tr th {
    border-top-color: #cad8de;
  }

  .handsontable.ht_master .htCore,
  .handsontable.ht_clone_top .htCore {
    padding-right: 0;
  }

  .handsontable th:not(:last-child),
  .handsontable.ht_clone_inline_start th,
  .handsontable td:not(:last-child) {
    border-right: none;
  }

  .handsontable.ht_clone_top th:nth-child(2),
  .handsontable.ht_master td:first-of-type {
    border-left: none;
    border-right: none;
  }

  .handsontable th,
  .handsontable tbody tr:nth-child(even) td,
  .handsontable.ht_clone_left tr:nth-child(even) th {
    background-color: #ffffff;
  }

  .handsontable.ht_clone_top_left_corner tr:first-child th:first-child,
  .handsontable.ht_clone_top tr:first-child th:first-child {
    border-radius: 8px 0 0 0;
  }

  .handsontable.ht_clone_top th:last-child {
    border-radius: 0 8px 0 0;
  }

  .handsontable.ht_clone_left tr:last-child:not(:first-child) th:first-child,
  .handsontable.ht_clone_top_left_corner tr:last-child:not(:first-child) th:first-child {
    border-radius: 0 0 0 8px;
  }

  .handsontable.ht_master tr:last-child td:last-child {
    border-radius: 0 0 8px 0;
  }

  .handsontable.ht_clone_top th {
    vertical-align: middle;
  }

  .handsontable.ht_clone_inline_start tr:first-child th,
  .handsontable.ht_master tr:first-child td {
    border-top-color: #f6f8fa;
  }

  .handsontable.ht_clone_top_left_corner,
  .handsontable.ht_clone_left tr:not(:last-child) th,
  .handsontable.ht_master tr:not(:last-child) td {
    border-bottom-color: #f6f8fa;
  }

  .handsontable th div.ht_nestingButton {
    right: 12px;
  }

  .handsontable th div.ht_nestingButton.ht_nestingCollapse::after {
    content: '⌄';
    font-size: 18px;
  }

  .handsontable th div.ht_nestingButton.ht_nestingExpand::after {
    content: '›';
    font-size: 18px;
  }

  .handsontable .rowHeader {
    font-size: 0;
  }

  .handsontable.ht_clone_top th {
    text-align: left;
  }

  .handsontable span.colHeader {
    font-weight: 500;
    white-space: normal;
  }

  .handsontable.ht_master td {
    color: #000000;
    white-space: normal;
    font-size: 12px;
  }

  .handsontable tbody th.ht__highlight,
  .handsontable thead th.ht__highlight {
    background-color: rgba(202, 216, 222, 0.3);
  }
`
